import { HttpContext, HttpContextToken } from "@angular/common/http";

export const NO_AUTHORIZATION_HEADER = new HttpContextToken<boolean>(() => false);

export const skipAuthHeader = () => {
    return new HttpContext().set(NO_AUTHORIZATION_HEADER, true);
}